import script from "./AiWorkbench.vue?vue&type=script&setup=true&lang=js"
export * from "./AiWorkbench.vue?vue&type=script&setup=true&lang=js"

import "./AiWorkbench.vue?vue&type=style&index=0&id=19e0d79e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e0d79e"]])

export default __exports__